$.fn.dataTable.Api.register( 'column().title()', function () {
    var colheader = this.header();
    return $(colheader).text().trim();
} );

import './dataTables.summary';
import './dataTables.checkedCheckboxes';
import './dataTables.filters';
import './dataTables.naturalSorting';
import './dataTables.polishSorting';


$.fn.dataTable.moment = function ( format, locale ) {
    var types = $.fn.dataTable.ext.type;

    // Add type detection
    types.detect.unshift( function ( d ) {
        return moment( d, format, locale, true ).isValid() ?
            'moment-'+format :
            null;
    } );

    // Add sorting method - use an integer for the sorting
    types.order[ 'moment-'+format+'-pre' ] = function ( d ) {
        return moment( d, format, locale, true ).unix();
    };
};
$.fn.dataTable.moment( 'DD/MM/YYYY HH:mm' );
$.fn.dataTable.moment( 'DD/MM/YYYY HH:mm:ss' );
$.fn.dataTable.moment( 'DD/MM/YYYY' );

$.fn.dataTableExt.oApi.fnGetPageOfRow = function (oSettings, iRow) {
    // get the displayLength being used
    var displayLength = oSettings._iDisplayLength;

    // get the array of nodes, sorted (default) and using current filters in place for all pages (default)
    // see http://datatables.net/docs/DataTables/1.9.beta.1/DataTable.html#%24_details for more detals
    var taskListItems = this.$("tr", { "filter": "applied" });

    // if there's more than one page continue, else do nothing
    if (taskListItems.length <= displayLength) return;

    // get the index of the row inside that sorted/filtered array
    var index = taskListItems.index(iRow);

    // get the page by removing the decimals
    var page = Math.floor(index / displayLength);

    // paginate to that page
    this.fnPageChange(page);
};

$.fn.dataTable.Api.register( 'changePageToFirstSelectedRow()', function () {
    let firstChecked = this.$('input[type="checkbox"]:checked').first().closest('tr')[0];

    if(firstChecked) {
        var rowsOnOnePage = this.page.len();
        var nodePosition = this.rows({order: 'current'}).nodes().indexOf(firstChecked);

        if(nodePosition !== -1) {
            var pageNumber = Math.floor(nodePosition / rowsOnOnePage);
            this.page(pageNumber).draw(false); //move to page with the element
        }
    }
} );
